export const LEAD_CONTACT_OPTIONS = {
  LEAD_FIRST_NAME: "Lead.FirstName",
  LEAD_LAST_NAME: "Lead.LastName",
  LEAD_FULL_NAME: "Lead.FullName",
  LEAD_PHONE: "Lead.Phone",
  LEAD_EMAIL: "Lead.Email",
  LEAD_SERVICE_INTERESTS: "Lead.ServiceInterests",
  LEAD_PREFERRED_CHANNEL: "Lead.PreferredChannel",
  LEAD_LOCATION_NAME: "Lead.ClinicName",
  LEAD_LOCATION_PHONE: "Lead.ClinicPhone"
};

export const LEAD_CONTACT_MENU_OPTIONS = {
  title: "Lead",
  menu: [
    { title: "Lead - First Name", value: LEAD_CONTACT_OPTIONS.LEAD_FIRST_NAME },
    { title: "Lead - Last Name", value: LEAD_CONTACT_OPTIONS.LEAD_LAST_NAME },
    { title: "Lead - Full Name", value: LEAD_CONTACT_OPTIONS.LEAD_FULL_NAME },
    { title: "Lead - Phone", value: LEAD_CONTACT_OPTIONS.LEAD_PHONE },
    { title: "Lead - Email", value: LEAD_CONTACT_OPTIONS.LEAD_EMAIL },
    {
      title: "Lead - Service Interests",
      value: LEAD_CONTACT_OPTIONS.LEAD_SERVICE_INTERESTS
    },
    {
      title: "Lead - Preferred Channel",
      value: LEAD_CONTACT_OPTIONS.LEAD_PREFERRED_CHANNEL
    },
    {
      title: "Clinic - Name",
      value: LEAD_CONTACT_OPTIONS.LEAD_LOCATION_NAME
    },
    {
      title: "Clinic - Phone",
      value: LEAD_CONTACT_OPTIONS.LEAD_LOCATION_PHONE
    }
  ]
};
